import React from 'react';
import { PortableText } from '@portabletext/react';

import Button from './Button';

import './PortableText.scss';

const Heading = (as, text) => {
  const Component = as;

  return <Component className="PortableTextHeading">{text}</Component>;
};

const Text = (text) => {
  return <p className="PortableTextTextLarge">{text}</p>;
};

const GradientText = ({ markType, children }) => {
  const gradient = markType === 'gradientTealToWhite' ? '#E0E9FB' : '#3882D9';
  return (
    <span
      style={{
        background: `linear-gradient(90deg, #00D1CA 33.65%, ${gradient} 100%)`,
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
      }}
    >
      {children}
    </span>
  );
};

const FleetPortableText = (props) => {
  const customComponents = {
    types: {
      button: Button,
    },
    list: {},
    listItem: {},
    marks: {
      gradientTealToBlue: GradientText,
      gradientTealToWhite: GradientText,
    },
    block: {
      h1: ({ children }) => Heading('h1', children),
      h2: ({ children }) => Heading('h2', children),
      h3: ({ children }) => Heading('h3', children),
      h4: ({ children }) => Heading('h4', children),
      h5: ({ children }) => Heading('h5', children),
      h6: ({ children }) => Heading('h6', children),
      paragraphLarge: ({ children }) => Text(children),
    },
  };

  return <PortableText value={props.blocks} components={customComponents} />;
};

export default FleetPortableText;
